import './vendors/swiper';
import openText from './components/open-text';
import turnContainerToLink from './components/container-click';
import initializeTooltips from './components/tooltips';
import addUrlParams from './components/add-url-params';
import backToTop from './components/b2t';
import stickyCTA from './components/sticky-cta';
import triggerTracking from './components/tracking';
import triggerEventTracking from './components/analytics/cta-events';
import triggerLinkTracking from './components/analytics/links';
import triggerProviderTracking from './components/analytics/providers';
import triggerProviderImpressions from './components/analytics/provider-impressions';
import tables from './components/tables';
import activateFAQs from './components/faqs';
import accordionContent from './components/accordion-content';
import systemAwards from './components/system-awards';
import handleRatingTip from './components/rating-tip';
import initARCTA from './components/ar-cta';
import initSecuritySystemFinder from './components/security-system-finder';
import initLivestream from './components/livestream';
import initTracking from './modules/tracking';
import initStateCities from './components/state-cities';

// console.log('Main JS loaded!');

accordionContent();
tables();
turnContainerToLink();
openText();
initializeTooltips();
addUrlParams();
backToTop();
stickyCTA();
triggerTracking();
triggerLinkTracking();
triggerEventTracking();
triggerProviderTracking();
triggerProviderImpressions();
activateFAQs();
systemAwards();
handleRatingTip();
initARCTA();
initSecuritySystemFinder();
initLivestream();
initTracking();
initStateCities();
